import { TradeInNotificationTypeEnum } from "../../../../common-deprecated/features/tradein/utils/tradeInAemUtilTypes";

const a11yLabels = {
    // A11Y
    carConfigA11yButtonToggleFuelInfo: "Toggle fuel info",
    carConfigA11yButtonToggleCo2Info: "Toggle co2 info",
    carConfigA11yButtonEdit: "Edit",
    carConfigA11yButtonCloseSearch: "Close search",
    carConfigA11yButtonToggleFilterMenu: "Toggle filter menu",
    carConfigA11yButtonMoreInfoAbout: "More info about",
    carConfigA11yButtonSlideNext: "Slide next",
    carConfigA11yButtonSlidePrevious: "Slide Previous",
    carConfigA11yButtonPacksAndExtrasSearchOpen: "Open search",
    carConfigA11yButtonPacksAndExtrasSearchClose: "Close search",
    carConfigA11yButtonPacksAndExtrasSearchFilters: "Open filters",
    carConfigA11yButtonAddToBasket: "Add {item} to basket",
    carConfigA11yButtonRemoveFromBasket: "Remove {item} from basket",
    carConfigA11yButtonPacksInfo: "See packs description",
    carConfigA11yButtonShowMorePacks: "Show more packs",
    carConfigA11yButtonShowLessPacks: "Show less packs",
    carConfigA11yButtonShowMoreEngines: "Show more engines",
    carConfigA11yButtonShowLessEngines: "Show less engines",
    carConfigA11yButtonShowMoreExtras: "Show more extras",
    carConfigA11yButtonShowLessExtras: "Show less extras",
    carConfigA11yButtonToggleSearch: "Toggle search",
    carConfigA11yButtonRotateSpinnerLeft: "Rotate spinner left",
    carConfigA11yButtonRotateSpinnerRight: "Rotate spinner right",

    carConfigA11yLinkSkipToAnchorsNavigation: "Skip to In-page anchor navigation",
    carConfigA11yNavAnchor: "In-page step anchors",
    carConfigA11yNavPanelNavigation: "Panel navigation",
    carConfigA11yButtonToggleSwitch: "Toggle switch",
    carConfigA11yPanelWinterWheels: "Winter wheels panel",
    carConfigA11yImageEprel: "Image of tyre specifications with eprel code {eprel}",
    carConfigA11yNavHighlights: "Highlights sections",
    carConfigA11yNavCTA: "Call to actions",
    carConfigA11yNavSpin: "Car spinner",
    carConfigA11yNavColour: "Colours",
    carConfigA11yNavUpholstery: "Upholstery",
    carConfigA11yNavWinterWheel: "Winterwheel toggle",
    carConfigA11yNavExtra: "Extra toggle",
    carConfigA11yNavSpecs: "Specs slider",
    carConfigA11yNavCharging: "Charging toggle",
    carConfigA11yLinkSkipToSpinContainer: "Skip to spin container",
    carConfigA11yLinkReturnToConfiguration: "Return to configuration",
    carConfigA11yButtonTogglePriceDisclaimer: "Toggle price disclaimer",
    carConfigA11yButtonTabNext: "Next tab",
    carConfigA11yButtonTabPrevious: "Previous tab",
    carConfigA11yLinkSkipToPromoDisclaimer: "Skip to promotion disclaimer",
    carConfigA11yLoading: "Loading",

    // sliders
    carConfigA11ySliderMoveStart: "Move slider to start",
    carConfigA11ySliderMoveEnd: "Move slider to end",
    carConfigA11yButtonToggleFullScreen: "Toggle Full Screen",

    // discliamers
    carConfigA11yButtonSwitchToCash: "Switch to cash",
    carConfigA11yButtonSwitchToFinance: "Switch to finance",

    // Notifications
    carConfigA11yPriceModeUpdated: "Price Mode Updated",
    carConfigA11yPriceModeUpdatedDescription: "The price mode updated to {pricemode} with a price of {price}",
    carConfigA11yFinanceModalOpened: "Finance personalisation opened",
    carConfigA11yCarSpinIsLoaded: "Car exterior 360 loaded",
    carConfigA11yCarSpinIsLoadedDescription:
        "The exterior 360 view is loaded and ready for use. Use mouse or keyboards to navigate the 360 vie",
    carConfigA11yInteriorSpinIsLoaded: "Car interior 360 loaded",
    carConfigA11yInteriorSpinIsLoadedDescription:
        "The interior 360 view is loaded and ready for use. Use mouse or keyboards to navigate the 360 vie",
    carConfigA11yEngineUpdated: "Engine is updated",
    carConfigA11yEngineUpdatedDescription: "The engine of your configuration has been changed to {engine}.",

    carConfigA11yPriceUpdated: "Price is updated",
    carConfigA11yPriceUpdatedDescription: "The price of your configuration is {price}",

    carConfigA11yColourUpdated: "Colour is updated",
    carConfigA11yColourUpdatedDescription: "The color of your configuration has been changed to {colour}.",
    carConfigA11yWheelUpdated: "Wheels updated",
    carConfigA11yWheelUpdatedDescription: "The wheels of your configuration has been changed to {wheel}.",
    carConfigA11yUpholsteryUpdated: "Upholstery updated",
    carConfigA11yUpholsteryUpdatedDescription: "The upholstery of your configuration has been changed to {upholstery}.",

    carConfigA11yHomechargerAdded: "{homecharger} added",
    carConfigA11yHomechargerRemoved: "{homecharger} removed",

    carConfigA11ySearchUpdatedTitle: "Search result updated",
    carConfigA11ySearchUpdatedDescription: "Showing results for {searchValue}",

    carConfigA11yPackAdded: "{pack} has been added",
    carConfigA11yPackRemoved: "{pack} has been removed",

    carConfigA11yExtraAdded: "{extra} has been added",
    carConfigA11yExtraRemoved: "{extra} has been removed",

    carConfigA11yInsuranceRemoved: "Insurance has been removed",
};

// LBX specific
export const carConfigLabelsLbx = {
    ...a11yLabels,
    carConfigLbxAtmosphereBase: "Base",
    carConfigLbxAtmosphereSophisticated: "Sophisticated",
    carConfigLbxAtmosphereDynamic: "Dynamic",
    carConfigLbxViewAtmosphere: "View atmosphere",
    carConfigLbxSelect: "Select",
    carConfigLbxSelected: "Selected",
    carConfigLbxRemove: "Remove",
    carConfigLbxWelcome: "Welcome to the LBX",
    carConfigLbxAtmosphere: "Atmosphere",
    carConfigLbxAtmosphereColour: "Exterior",
    carConfigLbxAtmosphereUpholstery: "Interior",
    carConfigLbxAtmosphereAlloys: "Alloys",
    carConfigLbxPowertrain: "Powertrain",
    carConfigLbxExteriorColour: "Exterior colour",
    carConfigLbxInteriorColour: "Interior colour",
    carConfigLbxChooseAtmosphere: "Choose atmosphere",
    carConfigLbxChooseAtmosphereIntro:
        "The LBX is powered by a new generation, self-charging Lexus hybrid electric system featuring a compact and lightweight 1.5-litre three-cylinder engine.",
    carConfigLbxDesignOptions: "Atmosphere design options",
    carConfigLbxAlloys: "Alloys",
    carConfigLbxAlloysIntro: "Alloys are selected by default with your chosen Atmosphere.",
    carConfigLbxPacksTitle: "Choose your equipment level (Pack)",
    carConfigLbxExtrasTitle: "Accessories",
    carConfigLbxPacksBase: "Base level pack",
    carConfigLbxPacksPremium: "Includes all <strong>tech pack</strong> features",
    carConfigLbxPacksAdvanced: "Includes <strong>tech</strong> & <strong>premium pack</strong> features",
    carConfigLbxPacksViewAll: "View all features",
    carConfigLbxBackToAtmospheres: "Back to all atmospheres",
    carConfigLbxPowertrainTitle: "Choose powertrain",
    carConfigLbxPowertrainDescription: "LBX powertrains feature the same lightweight 1.5L three-cylinder engine.",
    carConfigLbxUpgradePack: "Upgrade your pack",
    carConfigLbxViewAll: "View all",
    carConfigLbxViewLess: "View less",
    carConfigLbxIncludedInPack: "Included in {pack}",
    carConfigLbxIncludedInPowertrain: "Included in powertrain",
    carConfigLbxCompareTitle: "All features and options",
    carConfigLbxCompareStyling: "Styling",
    carConfigLbxCompareIncludedFeatures: "Included Features",
    carConfigLbxComparePowerTrains: "Powertrains",
    carConfigLbxComparePacks: "Packs",
    carConfigLbxCompareCollapseAll: "Collapse All",
    carConfigLbxCompareExpandAll: "Expand All",
    carConfigLbxCompareExterior: "Exterior",
    carConfigLbxCompareInterior: "Interior",
    carConfigLbxCompareFabric: "Interior Fabric",
    carConfigLbxCompareAlloys: "Alloys",
    carConfigLbxCompareFeatures: "Features",
    carConfigLbxCompareShared: "Shared",
    carConfigLbxCompareUnique: "Unique",
    carConfigLbxGradeWheeldrive: "Powertrain",
    carConfigLbxGradeWheeldriveFront: "Front Wheel Drive",
    carConfigLbxGradeWheeldriveAll: "All Wheel Drive",
    carConfigLbxGradeWheeldriveFrontOrAll: "Front or All Wheel Drive",
    carConfigLbxGradeExteriorColor: "Exterior color",
    carConfigLbxGradeExteriorColorMonotone: "Monotone",
    carConfigLbxGradeExteriorColorBiTone: "Bi-Tone",
    carConfigLbxGradeInteriorColor: "Interior trim",
    carConfigLbxGradeWheels: "Alloys",
    carConfigLbxGradeAvailablePacks: "Available packs",
    carConfigLbxGradeViewPacks: "Available packs",
    carConfigLbxStartingPrice: "LBX starts from",
    carConfigLbxSupportedPowertrainPacks: "Supported powertrain",
    carConfigLbxPacksFeatureCount: "Features ({count})",
    carConfigLbxWheeldriveIncludedPacks: "Available with {packs} packs",
    carConfigLbxSelectWheel: "Select",
    carConfigLbxCompareSelectToCompare: "Select",
    carConfigLbxUpsellPacksTitle: "upgrade your atmosphere and get access to high-end features",
    carConfigLbxUpsellPacksItems:
        "<li>Active Noise Control</li> <li>Smart digital key</li> <li>Panoramic View Monitor</li> <li>Lane Change Assiat (LCA)</li>",
    carConfigLbxPacks: "Packs",
    carConfigLbxExtras: "Accessories",
    carConfigLbxOverviewTileExtras: "Extras",
    carConfigLbxOverviewTilePacks: "Packs",
    carConfigLbxOverviewExtrasRemove: "Remove",
    carConfigLbxOverviewExtrasBrowse: "Browse extras",
};
export const carConfigLabels = {
    carConfigIntroText: "<strong>Configure your perfect car</strong>, from alloy to accessories",
    carConfigOptionalPackExtrasRemovedNotificationTitle: "",
    carConfigOptionalPackExtrasRemovedNotificationDescription: "",
    extrasRemovedNotificationTitle: "Configuration update",
    extrasRemovedNotificationDescription:
        "One or more of your selected extras have been removed as you selected a pack that includes them",
    carConfigChangeGrade: "Select a <strong>Grade</strong>",
    carConfigMainTitle: "Configure your {model}",
    carConfigEngine: "Engine",
    carConfigColour: "Colour",
    carConfigHighlights: "Highlights",
    carConfigConfigure: "Configure",
    carConfigSpecs: "Specs",
    carConfigPacks: "Packs",
    carConfigPacksAndExtras: "Packs & Extras",
    carConfigPacksLearnMore: "Learn More",
    carConfigPacksSidepanelTitle: "{title} <em>{count} extras</em>",
    carConfigPacksExtaCount: "{count} extras",
    carConfigPacksNotFound: "No packs were found",
    carConfigPacksShowAll: "Show all packs",
    carConfigPacksShowLess: "Show less packs",
    carConfigEnginesShowAll: "Show all engines",
    carConfigEnginesShowLess: "Show less engines",
    carConfigExtras: "Extras",
    carConfigExtrasLearnMore: "Learn More",
    carConfigExtrasAvailableInPack: "Also available in the <strong>{pack}</strong>",
    carConfigExtrasIncludedInPack: "selected in the <strong>{pack}</strong>",
    carConfigExtrasNotFound: "No extras were found",
    carConfigExtrasShowAll: "Show all extras",
    carConfigExtrasShowLess: "Show less extras",
    carConfigUpholstery: "Upholstery",
    carConfigInterior: "Interior",
    carConfigGallery: "Gallery",
    carConfigWheels: "Wheels",
    carConfigWheelsToggle: "Wheels",
    carConfigSummaryFittingCosts: "Fitting costs billed at dealer",
    carConfigWinterWheelsToggle: "Winter wheels",
    carConfigWinterWheelsTitle: "Would you like your winter wheels fitted?",
    carConfigWinterWheelsFittingTitle: "Would you like your winter wheels fitted?",
    carConfigWinterWheelsFittingDescription: "Add an optional winter wheel set, which can be fitted or packaged to go",
    carConfigWinterWheelsCheckbox: "Yes, please fit my winter wheels",
    carConfigWinterWheelsCheckboxWithPrice: "Yes, please fit my winter wheels for {price}",
    carConfigWheelSetPartNumber: "P/N {setPartNumber}",
    carConfigWheelTyreName: "Tyre Size {tyreName}",
    carConfigWheelMoreInfo: "Wheel info",
    carConfigTyreInfo: "Tyre info",
    carConfigfuelEfficiency: "Fuel efficiency",
    carConfignoise: "Noise",
    carConfigwetGrip: "Wet Grip",
    carConfigIncluded: "Included",
    carConfigFinanceNotificationTitle: "Finance has been updated",
    carConfigFinanceNotificationDescription: "Your finance details have been updated with the selected items.",
    carConfigFinanceErrorNotificationTitle: "Finance failed to load",
    carConfigFinanceErrorNotificationDescription: "Your finance details could not be loaded.",
    carConfigInsuranceNotificationTitle: "Insurance has been updated",
    carConfigInsuranceNotificationDescription: "Your insurance has been updated with the selected items.",
    carConfigBuyNow: "Buy now",
    carConfigSelectNow: "Select now",
    carConfigBuyFor: "",
    carConfigSelectFor: "",
    carConfig360SpinCar: "Car",
    carConfig360SpinWheel: "Wheel",
    carConfigFinanceOptions: "Finance Options",
    carConfigInsuranceTab: "Insurance",
    carConfigInsuranceTabMoreInfo: "More Info",
    carConfigInsuranceTabPriceDisclaimer:
        '*Insurance price is based on an indicative quote and is not included in total price. Contact <a href="#" target="_blank" rel="noopener noreferrer">Toyota Assurance Advisor</a> to validate your quote.',
    carConfigInsuranceTabServicesDisclaimer: "Note that services won't be included in your payment.",
    carConfigBusinessLeasingTab: "Business Leasing",
    carConfigEditFinancePlan: "Edit plan",
    carConfigOpenFinanceCalculator: "Open Finance Calculator",
    carConfigFinanceInfo: "",
    carConfigInsuranceInfo: "",
    carConfigEngineLearnMore: "Learn more",
    carConfigEngineShowMore: "Show more",
    carConfigEngineShowLess: "Show less",
    carConfigAccessoryDisclaimer: "",
    carConfigHomeChargerDisclaimer: "",
    carConfigMyConfigurations: "My configurations",
    carConfigSpecsTitle: "Everything in detail",
    carConfigSpecifications: "Specifications",
    carConfigTechSpecs: "Technical specifications",
    carConfigCashPurchase: "Cash purchase",
    carConfigMonthlyPurchase: "Financing",
    carConfigInsurance: "Insurance",
    carConfigAddInsurance: "Add",
    carConfigPartExchange: "Part Exchange",
    carConfigPartExchangeTitle: "Part exchange",
    carConfigAddPartExchange: "Add",
    carConfigEditPartExchange: "Edit",
    carConfigRemovePartExchange: "Remove",
    carConfigCashTotal: "Cash total",
    carConfigMontlyTotal: "Monthly total",
    carConfigInsuranceTotal: "Insurance total",
    carConfigServicesTitle: "Insurance", // For now, we only have insurance, but the section will then become services
    carConfigInsuranceTitle: "Toyota Car Insurance",
    carConfigInsuranceText: "Comprehensive cover specifically designed for Toyota owners.",
    carConfigInsuranceCta: "Get a quote",
    carConfigInsuranceEditCta: "Edit",
    carConfigOverviewDetailsTitle: "Overview details",
    carConfigOverviewTitle: "Overview",
    carConfigOverviewTileEngine: "Engine",
    carConfigOverviewTileColour: "Colour",
    carConfigOverviewTileWheels: "Wheels",
    carConfigOverviewTileWheelsSubtitle: "Wheels",
    carConfigOverviewTileWinterWheelsSubtitle: "Winter wheels",
    carConfigOverviewTileFittingCosts: "Fitting costs billed at dealer",
    carConfigOverviewTileUpholstery: "Upholstery",
    carConfigOverviewTilePacks: "Packs & Extras",
    carConfigOverviewTilePriceStartingPrice: "Starting price",
    carConfigOverviewTilePriceTotalPrice: "Total price",
    carConfigOverviewPacksRemove: "Remove",
    carConfigOverviewChargingRemove: "Remove",
    carConfigOverviewEdit: "Edit",
    carConfigOverviewRemove: "Remove",
    carConfigOverviewPacksBrowse: "Browse",
    carConfigOverviewChargingBrowse: "Browse",
    carConfigPacksSearchPacksLabel: "Search packs",
    carConfigPacksSearchPacksPlaceholder: "Search in packs",
    carConfigPacksSearchExtrasLabel: "Search extras",
    carConfigPacksSearchExtrasPlaceholder: "Search in extras",
    carConfigDelivery: "Delivery",
    carConfigNoDelivery: "",
    carConfigDeliverySingleWeek: "1 week",
    carConfigDeliveryWeeks: "from {weeks} weeks",
    carConfigSimilarCars: "See similar cars available sooner",
    carConfigSimilarCarsModalTitle: "Cars with prior delivery",
    carConfigSimilarCarSelect: "Select",
    carConfigRepresentativeExample: "Representative example",
    carConfigReadCoreFinanceTerms: "*Representative example. Read core finance terms",
    carConfigSelectedFinancePlan: "You have selected a {financeProductName}",
    carConfigSpecsSpaceAndRoom: "Space & Room",
    carConfigSpecsSpaceAndRoomDescription: "Space & Room description",
    carConfigSpecsSpaceAndRoomSecondaryDescription: "Space & Room description",
    carConfigSpecsEngine: "Engine",
    carConfigSpecsEngineDescription: "Engine description",
    carConfigSpecsEngineSecondaryDescription: "Engine description",
    carConfigSpecsSafety: "Safety",
    carConfigSpecsSafetyDescription: "Safety description",
    carConfigSpecsSafetySecondaryDescription: "Safety description",
    carConfigSpecsStyling: "Styling",
    carConfigSpecsStylingDescription: "Styling description",
    carConfigSpecsStylingSecondaryDescription: "Styling description",
    carConfigSpecsPerformance: "Performance",
    carConfigSpecsPerformanceDescription: "Performance description",
    carConfigSpecsPerformanceSecondaryDescription: "Performance description",
    carConfigSpecsWheels: "Wheels",
    carConfigSpecsWheelsDescription: "Wheels description",
    carConfigSpecsWheelsSecondaryDescription: "Wheels description",
    carConfigSpecsComfort: "Comfort",
    carConfigSpecsComfortDescription: "Comfort description",
    carConfigSpecsComfortSecondaryDescription: "Comfort description",
    carConfigSpecsMultimedia: "Multimedia",
    carConfigSpecsMultimediaDescription: "Multimedia description",
    carConfigSpecsMultimediaSecondaryDescription: "Multimedia description",
    carConfigSpecsStorage: "Storage",
    carConfigSpecsStorageDescription: "Storage description",
    carConfigSpecsStorageSecondaryDescription: "Storage description",
    carConfigSpecsProtection: "Protection",
    carConfigSpecsProtectionDescription: "Protection description",
    carConfigSpecsProtectionSecondaryDescription: "Protection description",
    carConfigSpecsLearnMore: "Learn more",
    carConfigSpecsSearchLabel: "Search specs",
    carConfigSpecsSearchPlaceholder: "Search",
    carConfigSpecsResultsEmpty: 'No results for "{searchValue}"',
    carConfigSpecsResultsEmptyFilters: "There aren't any results for selected filters, ",
    carConfigSpecsResultsEmptyFiltersButton: 'click here to change the filters to "{otherFilters}"',
    carConfigOrderSummary: "Order summary",
    // ----------------------------------------------------------------------
    // Tycode section
    // ----------------------------------------------------------------------

    carConfigSummaryTyCodeTitle: "The Toyota code for your configuration",
    carConfigSummaryTyCodeYourConfiguration: "Your configuration code",
    carConfigSummaryTyCodeLinkTitle: "Configuration link",
    carConfigSummaryTyCodeDescription:
        "                With the Toyota configuration code, you can access your build again at any time and share it with your\n" +
        "                Toyota centre or other people. Just enter the code displayed on the model selection page, for example,\n" +
        "                or simply copy the generated link to your configuration.",
    carConfigSummaryTyCodeScanDescription:
        "Alternatively, you can scan the QR code below to access your build on your phone",
    carConfigSummaryTyCodeCopyCode: "Copy code",
    carConfigSummaryTyCodeCopyLink: "Copy link",
    carConfigSummaryTyCodeCopied: "Copied",

    // ----------------------------------------------------------------------
    carConfigActionsSaveButtonLabel: "Save to My Toyota",
    carConfigActionsTyCodeButtonLabel: "Share my code",
    carConfigActionsTyCodeSaving: "Loading",
    carConfigActionsTyCodeError: "Could not save configuration",
    carConfigActionsTyCodeTitle: "My configuration",
    carConfigActionsTyCodeText: "Show this code to your dealer to review your configuration.",
    carConfigActionsQuickLinksButtonLabel: "Quick links",
    carConfigActionsQuickLinksTitle: "Quick links",
    carConfigTotalPrice: "Total price",
    carConfigPromoFromUntilDate: "Valid from {from} until {until}",
    carConfigPromoFromDate: "Valid from {from}",
    carConfigPromoUntilDate: "Valid until {until}",
    carConfigBackToModelPage: "Back to model page",
    carConfigCharging: "Charging",
    carConfigChargingOptions: "Charging options",
    carConfigPublicCharging: "Public charging",
    carConfigChargingAtHome: "Charging at home",
    carConfigCashPriceDisclaimer: "",
    carConfigWantToChargeAtHome: "I want to charge at home",
    carConfigHomeChargeInstallation: "HomeCharge installation",
    carConfigCalculateChargingTimeAndRange: "Calculate time & range",
    carConfigPublicChargingLearnMore: "Learn more",
    carConfigPaymentMethod: "Selected payment",
    carConfigBuyCash: "Buy with cash online",
    carConfigBuyMonthly: "Buy with monthly payments online",
    carConfigLease: "Lease with monthly payments online",
    carConfigReserve: "Reserve",
    carConfigPartOfPack: "Part of {pack}",
    carConfigViewPack: "View Pack",
    carConfigViewPacks: "View Packs",
    carConfigNewColoursAvailableTitle: "New colours available",
    carConfigNewColoursAvailableDescription:
        "This pack contains new colour options. You can find the new options in the colour section.",
    carConfigNewUpholsteriesAvailableTitle: "New upholstery options available",
    carConfigNewUpholsteriesAvailableDescription:
        "This pack contains new upholstery options. You can find the new options in the upholstery section.",
    carConfigNewItemsAvailableButton: "Take me there",
    carConfigPackUnavailableForCurrentColour: "Unavailable for current colour",
    carConfigPackUnavailableForCurrentUpholstery: "Unavailable for current upholstery",
    carConfigViewColours: "View colours",
    carConfigViewUpholsteries: "View upholsteries",
    carConfigPackRemovedNotificationTitle: "One of your selected packs has been removed",
    carConfigPackRemovedDueIncompatibleColourNotification:
        "One or more of your configured packs is not available for your current colour selection.",
    carConfigPackRemovedDueIncompatibleUpholsteryNotification:
        "One or more of your configured packs is not available for your current upholstery selection.",
    carConfigBackToCashPurchase: "Back to cash purchase",
    carConfigBackToFinance: "Back to finance",
    carConfigCashToggle: "Cash purchase",
    carConfigFinanceToggle: "Finance",
    carConfigSwitchToCash: "Switch to cash",
    carConfigSwitchToFinance: "Switch to finance",

    // ----------------------------------------------------------------------
    // Integrated trade-in notifications
    // ----------------------------------------------------------------------

    carConfigTradeinNotificationUpdate: "Part Exchange Update",
    carConfigTradeinNotificationTooHighCash: "Your car valuation is higher than the total value of the car",
    carConfigTradeinNotificationTooHighMonthly:
        "Your car valuation is too high and can not be used with a monthly finance plan",

    // Integrated trade-in validation scenarios.
    // Half of these are currently unused (errors are now hidden) but keeping them here to maintain an overview.
    // Explanation of scenarios: https://cde.toyota-europe.com/confluence/display/OR/Finance+scenarios
    carConfigTradeinNotificationAdded: "We have successfully added your part exchange to your finance quote", // Scenario 1
    carConfigTradeinNotificationReducedDeposit:
        "We have successfully added your part exchange to the finance deposit but reduced your cash deposit", // Scenario 2
    carConfigTradeinNotificationRefused:
        "We can not use your part exchange in the finance deposit because it exceeds the maximum allowed deposit", // Scenario 3
    carConfigTradeinNotificationReducedDepositCarValue:
        "We reduced your cash deposit because the total value of the car decreased", // Scenario 5A
    carConfigTradeinNotificationRefusedCarValue:
        "We removed your part exchange from the deposit because the total value of the car decreased and the part exchange is now over the maximum deposit", // Scenario 5B
    carConfigTradeinNotificationRefusedCarValueDeposit:
        "We removed your part exchange from the deposit because the total value of the car decreased and the part exchange is over the maximum deposit. We also increased your cash deposit to match the finance settings.", // Scenario 5C
    carConfigTradeinNotificationAddedCarValue:
        "We added your part exchange to the finance deposit because the total value of the car increased and the part exchange value is now below the maximum allowed deposit", // Scenario 6
    carConfigTradeinNotificationAddedCash: "We have subtracted your part exchange value from the total car price",
    carConfigTradeinNotificationRefusedCash:
        "Your part exchange cannot be used as it has a higher value than the total car price",
    carConfigTradeInNotificationNotSupported: "Part exchange is not available in PCH leasing",
    carConfigTradeInBasketRefusedFinanceProduct:
        "Your part exchange valuation cannot be used with PCH. Switch to Cash or PCP to use your part exchange valuation.  Or continue with PCH and discuss selling your part exchange with your nearest Toyota Centre.",
    carConfigHighlightsLearnMore: "Learn more",
    carConfigHighlightsOverview: "Overview",
    carConfigHighlightsIconicFeatures: "Hello iconic <span>features</span> of {model}",
    carConfigExchangeRate: "Fixed conversion rate: {primaryPrice} = {secondaryPrice}",
    carConfigCostsAndTaxes: "Tax and Costs",
    carConfigCostsAndTaxesDescription:
        "Immatruculation tax is calculated based on the region you live in. Please select your region to calculate the exact cost.",
    carConfigCostsAndTaxesSelectTitle: "Select an option...",
    carConfigCostsAndTaxesSearch: "Search...",
    carConfigNo: "No",
    carConfigYes: "Yes",
    carConfigTooltipClose: "Got it",
    carConfigGazooRacing: "Gazoo Racing",

    // Fueltype
    hybrid: "Hybrid",
    electric: "Electric",
    plugin: "Plug-in Hybrid",
    fuelCell: "Fuel Cell",
    hybridAvailable: "Hybrid Available",
    diesel: "Diesel",
    petrol: "Petrol",

    // sliders
    ariaMoveSliderStart: "Move slider to start",
    ariaMoveSliderEnd: "Move slider to end",

    // Tyre labels
    tyreInfoFallback: "Detail page",
    tyreInfoFallbackDescription: "This image could not be loaded. To see more information go to:",

    // Disclaimers
    genericDisclaimer: "",
    genericFinanceDisclaimer: "",
    genericSpecsDisclaimerTitle: "",
    genericSpecsDisclaimer: "",
    genericHighlightsDisclaimerTitle: "",
    genericHighlightsDisclaimer: "",
    genericEngineDetailsDisclaimer: "",

    // AvailableInOtherGrades
    carConfigAvailableInOtherGradesSummaryTitle: "Available in other grades",
    carConfigSelectAvailableEngineInOtherGrade:
        "To select this engine option, switch to {model} {newGrade}. Some features, specs, configurations and costs will differ from your current {model} {currentGrade}.",
    carConfigSelectAvailableEngineInOtherGrades:
        "To select this engine option, switch to one of the grades below. Some features, specs, configurations and costs will differ from your current {model} {currentGrade}.",
    carConfigSelectAvailableColourInOtherGrade:
        "To select this colour option, switch to {model} {newGrade}. Some features, specs, configurations and costs will differ from your current {model} {currentGrade}.",
    carConfigSelectAvailableColourInOtherGrades:
        "To select this colour option, switch to one of the grades below. Some features, specs, configurations and costs will differ from your current {model} {currentGrade}.",
    carConfigSelectAvailableWheelInOtherGrade:
        "To select this wheel option, switch to {model} {newGrade}. Some features, specs, configurations and costs will differ from your current {model} {currentGrade}.",
    carConfigSelectAvailableWheelInOtherGrades:
        "To select this wheel option, switch to one of the grades below. Some features, specs, configurations and costs will differ from your current {model} {currentGrade}.",
    carConfigSelectAvailableUpholsteryInOtherGrade:
        "To select this upholstery option, switch to {model} {newGrade}. Some features, specs, configurations and costs will differ from your current {model} {currentGrade}.",
    carConfigSelectAvailableUpholsteryInOtherGrades:
        "To select this upholstery option, switch to one of the grades below. Some features, specs, configurations and costs will differ from your current {model} {currentGrade}.",

    carConfigSelectAvailableItemInOtherGradeWarning:
        "Changing grades will remove all currently selected packs & extras.",
    carConfigAvailableInOtherGradeCloseModal: "Back to {model} {currentGrade}",
    carConfigAvailableInOtherGradeSwitchGrade: "Switch grade",
    carConfigAvailableInOtherGradeYouWillKeep: "You'll keep",
    carConfigAvailableInOtherGradeYouWillLose: "You'll lose",
    carConfigAvailableInOtherGradeTotalPrice: "From {price}",
    carConfigAvailableInOtherGradeMonthlyPrice: "or {price} / month",

    // WLTP
    carConfigWltpTax: "", // Includes 1st Year VED based on CO2 emissions of {co2}. This needs to be present in order to have the co2 tax displayed. {co2} variable is optional.
    carConfigCo2Disclaimer:
        "Some optional equipment may lead to an increase of CO2, hence have an impact on tax and a total cost of the car",

    // Calculator error modal
    carConfigCalculatorErrorTitle: "This is taking too long.",
    carConfigCalculatorErrorDescription: "Something is wrong. Try refreshing the page or try again later.",
    carConfigCalculatorErrorButton: "Try again",

    // Retailer specific
    carConfigRetailerConfigurationQRCodeTitle: "Scan QR code",
    carConfigRetailerConfigurationQRCodeText: "Scan the code with your smartphone by using your phone's camera.",

    // Retailer specific Toyota
    carConfigRetailerModelHighlights: "Explore the {model}",
    carConfigRetailerModelSpecifications: "{model} {currentGrade} Specifications",
    carConfigRetailerGrade: "Grade",
    carConfigRetailerPacksFilter: "Filter",
    carConfigRetailerOptionsAvailable: "{count} options available",
    carConfigRetailerOptionAvailable: "1 option available",
    carConfigRetailerPacksAvailable: "{count} packs available",
    carConfigRetailerPackAvailable: "1 pack available",
    carConfigRetailerYourModelGrade: "Your {model} {currentGrade}",
    carConfigRetailerClose: "Close",

    // Retailer specific Lexus
    carConfigRetailerBackToModelSelection: "Back to model selection",
    carConfigRetailerPriceTabsCash: "Cash purchase",
    carConfigRetailerPriceTabsFinance: "Finance options",
    carConfigRetailerPriceEstimatedCash: "Estimated total",
    carConfigRetailerPriceEstimatedFinance: "Estimated monthly",
    carConfigRetailerConfigurationTitle: "Your configuration ID",
    carConfigRetailerConfigurationLinkTitle: "Your customisation",
    carConfigRetailerConfigurationLinkText: "View the customisation link of your selected car with the best offer.",
    carConfigRetailerRestartConfiguration: "Restart configuration",

    carConfigExtraPartOfPackTitle: "This extra is part of the {pack}",
    carConfigExtraPartOfPackSubtitle: "Would you like to:",

    carConfigOnlyAddExtra: "<strong>Only add this extra</strong> to your configuration?",
    carConfigOnlyAddPack: "<strong>Add the full pack</strong> to your configuration? (Includes all items in the pack.)",

    carConfigSelectEngine: "Select engine",
    carConfigSelectWheel: "Select wheel",

    carConfigAddPackToBasket: "Add pack",
    carConfigRemovePackFromBasket: "Remove pack",

    carConfigAddExtraToBasket: "Add extra",
    carConfigRemoveExtraFromBasket: "Remove extra",

    ...carConfigLabelsLbx,
};

export type CarConfigLabelType = keyof typeof carConfigLabels;
export const carConfigIntegratedTradeInNotificationsLabels: Record<TradeInNotificationTypeEnum, CarConfigLabelType> = {
    [TradeInNotificationTypeEnum.Added]: "carConfigTradeinNotificationAdded",
    [TradeInNotificationTypeEnum.ReducedDeposit]: "carConfigTradeinNotificationReducedDeposit",
    [TradeInNotificationTypeEnum.Refused]: "carConfigTradeinNotificationRefused",
    [TradeInNotificationTypeEnum.AddedCarValue]: "carConfigTradeinNotificationAddedCarValue",
    [TradeInNotificationTypeEnum.ReducedDepositCarValue]: "carConfigTradeinNotificationReducedDepositCarValue",
    [TradeInNotificationTypeEnum.RefusedCarValue]: "carConfigTradeinNotificationRefusedCarValue",
    [TradeInNotificationTypeEnum.RefusedCarValueDeposit]: "carConfigTradeinNotificationRefusedCarValueDeposit",
    [TradeInNotificationTypeEnum.AddedCash]: "carConfigTradeinNotificationAddedCash",
    [TradeInNotificationTypeEnum.RefusedCash]: "carConfigTradeinNotificationRefusedCash",
    [TradeInNotificationTypeEnum.NotSupported]: "carConfigTradeInNotificationNotSupported",
};
